import { CATALOG_URL } from 'api/CatalogAPI';
import { FieldType } from 'modules/domains';
import { useRestQuery } from 'utils/hooks/api/useRestQuery';

export type DefinedMappings = Record<string, FieldType>;

export type CatalogFieldMappings = {
  definedMappings?: DefinedMappings;
  undefinedFields: string[];
};

// Underlying REST query for catalog mappings
export const useCatalogFieldMappings = (name = '') =>
  useRestQuery<CatalogFieldMappings>(
    name.length > 0 ? `${CATALOG_URL}/${name}/fieldMappings` : undefined,
  );
